import { render, staticRenderFns } from "./HomeBox.vue?vue&type=template&id=0d679d18&"
import script from "./HomeBox.vue?vue&type=script&lang=js&"
export * from "./HomeBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports